
import Z404 from './404.vue';
export default Z404